import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import BankService from '../../core/BankService'

export const postAssetQuality = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/assetQuality',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BankService.postAssetQuality(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadAssetQuality = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/assetQuality/export',
  async (params) => {
    try {
      const res = await BankService.downloadAssetQuality(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
